import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import ExpenseTypesApi from '../api/ExpenseTypes.api';

export type ExpenseTypeActivity = { isActivePayable: boolean | null; isActiveReceivable: boolean | null };

/**
 * Re-reads one charge type's activity flags (`ExpenseTypeQuery`). Nothing is sent on mount; each
 * read goes to the network, as the grid's former `useQuery(Find, { skip: true }).refetch` did.
 */
export function useExpenseTypeActivity() {
  const client = useApolloClient();
  const readActivity = useCallback(
    async (id: number): Promise<ExpenseTypeActivity | null> => {
      const { data } = await client.query({
        query: ExpenseTypesApi.Find,
        variables: { id },
        fetchPolicy: 'network-only',
      });
      const expenseType = data?.expenseType;
      if (!expenseType) return null;
      return {
        isActivePayable: expenseType.isActivePayable ?? null,
        isActiveReceivable: expenseType.isActiveReceivable ?? null,
      };
    },
    [client]
  );
  return { readActivity };
}
